import { REWARD_OFFERING } from "../../constants";
import OnboardingPage from "../../common/components/OnboardingPage";
import DualCouponBox from "../../common/components/DualCouponBox";
import { getRedeemUrlWithContext } from "../../utils";

const cfg = GLOBAL_CFG["trip-com"];

function TripComMain() {
  const redeemUrl = getRedeemUrlWithContext("trip-com");

  return (
    <OnboardingPage
      redeemUrl={redeemUrl}
      rewardId={REWARD_OFFERING.tripCom}
      customContent={
        <>
          <DualCouponBox
            coupons={cfg.dualCoupons.items}
            copySvg={cfg.dualCoupons.copySvg}
            copyDoneSvg={cfg.dualCoupons.copyDoneSvg}
          />
          <p className="subtitle-p">T&amp;Cs and exclusions apply.</p>
        </>
      }
    />
  );
}

export default TripComMain;
